import Vue from "vue";

Vue.component('back-button', require('@/components/BackButton').default);
Vue.component('auth-token', require('@/components/auth/Token').default);
Vue.component('no-results-found', require('@/components/NoResultsFound').default);
Vue.component('page-header', require('@/components/PageHeader').default);
Vue.component('loading-bar', require('@/components/LoadingBar').default);
